<template>
  <div
    class="Cart-Summary__GWP"
    :class="modifierClass"
    v-if="isActive && !auto"
  >
    <p class="t4 Cart-Summary__GWP-Title" :class="{ visible: !collapsed }">
      {{ store.terms.gwp.title }}
    </p>
    <div class="Cart-Summary__GWP-Upsell" :class="{ visible: !collapsed }">
      <Upsell
        :items="items"
        v-if="items && items.length > 0"
        location="gwp-upsell"
      />
    </div>
    <button
      role="button"
      type="button"
      @click="toggleGWP"
      class="Cart-Summary__GWP-Toggle"
      :class="toggleClasses"
    >
      {{ toggleMessage }}
    </button>
  </div>
</template>

<script setup>
import { pubSub } from '@utils/PubSub';
import { ref, computed, watch } from 'vue';
import { useCartStore } from './Composables/Store';
import { formatID } from '@src/js/utils/format';

import Upsell from '../Global/Upsell.vue';

const store = useCartStore();

const items = ref(false);
const collapsed = ref(false);
const auto = ref(false);

const toggleMessage = computed(() => {
  if (collapsed.value) {
    return store.terms.gwp.cta_collapsed;
  } else {
    return store.terms.gwp.cta;
  }
});

const toggleClasses = computed(() => {
  if (collapsed.value) {
    return `t4 Cart-Summary__GWP-Toggle--Collapsed`;
  } else {
    return `p5 underline`;
  }
});

const modifierClass = computed(() => {
  if (isActive.value && items.value && items.value.length <= 1) {
    return 'Cart-Summary__GWP--Single';
  } else {
    return '';
  }
});

pubSub.subscribe('theme:gwp:added', store.gwpAdded);
pubSub.subscribe('theme:gwp:remove', store.removeGWP);
const toggleGWP = () => (collapsed.value = !collapsed.value);
const isActive = computed(() => store.gwpCriteriaMet);
watch(isActive, () => {
  // If there's only one product with a single variant, auto-add.
  auto.value = items.value.length === 1 && items.value[0].variants.length === 1;

  if (auto.value && isActive.value) {
    // Add auto-add variant by getting the variant ID
    const variantId = formatID(items.value[0].variants[0].id);
    const quantity = '1';
    const properties = {
      '_gift-with-purchase': true,
      _freeGift: true,
    };

    const payload = {
      id: variantId,
      quantity,
      properties,
    };

    document.dispatchEvent(
      new CustomEvent('theme:add-to-cart', {
        detail: payload,
      })
    );

    pubSub.publish('theme:gwp:added');
  }
});

try {
  const handles = store?.gwp?.products.trim().split(',') ?? [];
  items.value = await store.fetchUpsellItems(handles);
} catch (err) {
  throw new Error(`Gift with Purchase Fetch failed: ${err}`);
}
</script>
